<template>
  <div class="customize_container" v-if="getImageUrlLoading">
    <div class="customize_title">
      <!-- <div class="step">Step 4</div> -->
      <div class="step_title">選擇你想要的大小與加工方式</div>
    </div>
    <div class="center">
      <div class="customize_step4">
        <form>
          <div class="process">
            <p>加工方式</p>
            <div
              class="description"
              v-for="(item, index) in wayData"
              :key="index"
            >
              <div
                class="item wayItem"
                v-on:click="updateWay(item.wayCode, index)"
              >
                {{ item.wayName }}
              </div>
              <div @click="lightboxControl(item.image)">
                <span>查看實體照片</span>
                <svg width="12" height="12" viewBox="0 0 12 12">
                  <g
                    fill="none"
                    fill-rule="evenodd"
                    transform="rotate(-45 5.292 3.465)"
                  >
                    <ellipse
                      cx="4"
                      cy="4.138"
                      stroke="#A8894C"
                      stroke-width="1.5"
                      rx="4"
                      ry="4.138"
                    ></ellipse>
                    <path
                      fill="#A8894C"
                      d="M4.912 7.759H3.5v4.868h1.412z"
                    ></path>
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <div class="size_weight">
            <div class="size-container">
              <div class="size" for>尺寸</div>
              <div class="cm_inch">
                <div class="cm activeCm" v-on:click="updateUnit('cm')">
                  公分
                </div>
                <div class="inch" v-on:click="updateUnit('tin')">台吋</div>
              </div>
            </div>
            <div class="weight" for>重量</div>
            <div class="dropdown_title">
              <a href="#" v-on:click.prevent="showDropDownSize">
                <div v-if="!isLength" class="title-color">請選擇尺寸</div>
                <div v-else>
                  {{ size.length }}
                  <span v-if="isUnitCm">公分</span>
                  <span v-else>台吋</span>
                </div>
                <i
                  :class="{
                    'fa-caret-up': showDropDown_size,
                    'fa-caret-down': !showDropDown_size,
                  }"
                  class="fa"
                  aria-hidden="true"
                ></i>
              </a>
              <transition name="slide-fade">
                <div class="choice" v-if="showDropDown_size">
                  <ul>
                    <li v-for="(data, index) in lengthData" :key="index">
                      <span class="item" v-on:click="updateLength(data)">
                        {{ data }}
                        <span v-if="isUnitCm">公分</span>
                        <span v-else>台吋</span>
                      </span>
                    </li>
                  </ul>
                </div>
              </transition>
            </div>
            <div class="dropdown_title">
              <a
                href="#"
                v-on:click.prevent="showDropDown_weight = !showDropDown_weight"
              >
                <div v-if="!isWeight" class="title-color">請選擇重量</div>
                <div v-else>{{ size.weight }}錢</div>
                <i
                  :class="{
                    'fa-caret-up': showDropDown_weight,
                    'fa-caret-down': !showDropDown_weight,
                  }"
                  class="fa"
                  aria-hidden="true"
                ></i>
              </a>
              <transition name="slide-fade">
                <div class="choice" v-if="showDropDown_weight">
                  <ul>
                    <li v-for="(data, index) in weightData" :key="index">
                      <span class="item" v-on:click="updateWeight(data)"
                        >{{ data }}錢</span
                      >
                    </li>
                  </ul>
                </div>
              </transition>
            </div>
          </div>
          <div
            v-if="$store.getters.getComponentCode === 'AY'"
            class="gold_note"
          >
            整組包含黃金青龍偃月刀以及春秋，重量固定，關刀約長12公分，春秋2.2*2.7公分
          </div>
          <div
            v-if="$store.getters.getComponentCode === 'AZ'"
            class="gold_note"
          >
            整組包含黃金火尖槍及乾坤圈，重量固定，火尖槍約長12公分，乾坤圈約直徑2.0公分
          </div>
          <div class="gold_price">
            {{
              $store.getters.getSpecialMemberState === 1
                ? "目前黃金價錢："
                : "目前黃金飾金價錢："
            }}{{ taiwaneseGoldPrice }} 台錢
          </div>
        </form>
        <div class="cart_price">
          <div class="btn">
            <button v-on:click="addToCart" :disabled="imgDataUrl == ''">
              加入購物車
            </button>
          </div>
          <div class="total_price">TWD {{ orderPrice }}</div>
        </div>
      </div>
      <div class="pic_changed">
        <div class="load" v-if="imgDataUrl == ''">
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
        </div>
        <img class="product" v-bind:src="imgDataUrl" v-else />
      </div>
    </div>
    <StepPreNext
      :hideNextButton="true"
      @preClick="$router.back()"
    ></StepPreNext>
    <div
      class="lightbox"
      v-bind:class="{ displaynone: closeLightbox }"
      v-body-scroll-lock="!closeLightbox"
    >
      <div class="center-container">
        <img v-bind:src="lightboxImg" />
        <div
          href="#"
          class="lightbox-close"
          @click="closeLightbox = !closeLightbox"
        >
          <img src="@/images/icon-close@2x-white.png" />
        </div>
      </div>
    </div>
  </div>
  <div class="load" v-else>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="loading-text">程式運算中，請耐心等候</div>
  </div>
</template>

<script>
import axios from "axios";
import StepPreNext from "@/components/StepPreNext.vue";

export default {
  name: "customizeStep4",
  components: {
    StepPreNext,
  },
  data() {
    return {
      showDropDown_size: false,
      showDropDown_weight: false,
      lengthWeightLimit: "",
      lengthData: [],
      weightData: [],
      size: {
        type: "normal",
        unit: "cm",
        length: "",
        weight: "",
        way: "",
      },
      closeLightbox: true,
      lightboxImg: "",
      orderPrice: "--",
      getImageUrlLoading: true,
      taiwaneseGoldPrice: "",
    };
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("updataCanvasDataUrl", "");
    next();
  },
  created() {
    this.initSetting();
  },
  mounted() {
    let wayItems = document.querySelectorAll(".wayItem");
    wayItems[0].classList.add("active");
  },
  watch: {
    showDropDown_size() {
      if (this.showDropDown_size == true) {
        this.showDropDown_weight = false;
      }
    },
    showDropDown_weight() {
      if (this.showDropDown_weight == true) {
        this.showDropDown_size = false;
      }
    },
    size: {
      handler(val) {
        if (val.weight !== "") {
          this.orderPrice = "--";
          this.getOrderPrice();
        }
      },
      deep: true,
    },
    // lengthWeightLimit() {
    //   this.changeLengthLimit(this.defaultWayByStyle);
    //   this.changeWeightLimit(
    //     this.lengthWeightLimit[this.defaultWayByStyle][0].min_weight
    //   );
    //   this.getOrderPrice();
    // },
    getImageUrl() {
      if (this.getImageUrl !== "") {
        this.saveToCookie();
        this.$store.dispatch("emptyCustomInfo");
        this.$router.push("/gold/cart/cart_order");
      }
    },
  },
  methods: {
    async initSetting() {
      if (this.$store.getters.getIsGoToStep3) {
        await this.getLengthWeightLimit();
      } else {
        this.$router.push("/gold/customize/customize_step1");
      }
      if (this.$store.getters.getSpecialMemberState === 1) {
        this.size.type = "peer";
      }
      this.setDefaultSize();
      this.changeLengthLimit(this.defaultWayByStyle);
      this.changeWeightLimit(
        this.lengthWeightLimit[this.defaultWayByStyle][0].cm_length
      );
      this.getOrderPrice();
      this.getGoldPrice();
      this.timeToLeave();
    },
    async getGoldPrice() {
      try {
        let res = await this.$store.dispatch("getGoldPrice");
        if (this.$store.getters.getSpecialMemberState === 1) {
          this.taiwaneseGoldPrice = res.goldStrip.ask_NT;
        } else {
          this.taiwaneseGoldPrice = res.goldAccessory.ask_NT;
        }
      } catch (e) {
        alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
      }
    },
    async getLengthWeightLimit() {
      try {
        let res = await axios({
          url: this.$store.getters.getGlobalUrl + "gold/weight-list",
          method: "get",
          headers: {
            "Content-Type": "application/json",
          },
        });
        this.lengthWeightLimit = res.data.data;
      } catch (e) {
        alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
      }
    },
    setDefaultSize() {
      this.size = {
        type: this.size.type,
        unit: "cm",
        length: this.lengthWeightLimit[this.defaultWayByStyle][0].cm_length,
        weight: this.lengthWeightLimit[this.defaultWayByStyle][0].min_weight,
        way: this.defaultWayByStyle,
      };
    },
    changeLengthLimit(way) {
      this.lengthData = [];
      if (this.size.unit == "cm") {
        this.lengthWeightLimit[way].forEach((item) => {
          this.lengthData.push(item.cm_length);
        });
      } else if (this.size.unit == "tin") {
        this.lengthWeightLimit[way].forEach((item) => {
          this.lengthData.push(item.tin_length);
        });
      }
    },
    changeWeightLimit(length) {
      this.weightData = [];
      let way = this.size.way;
      let maxWeight = "";
      let minWeight = "";
      this.lengthWeightLimit[way].forEach((item) => {
        if (this.size.unit == "cm") {
          if (item.cm_length == length) {
            maxWeight = parseFloat(item.max_weight);
            minWeight = parseFloat(item.min_weight);
          }
        } else if (this.size.unit == "tin") {
          if (item.tin_length == length) {
            maxWeight = parseFloat(item.max_weight);
            minWeight = parseFloat(item.min_weight);
          }
        }
      });
      for (let i = minWeight * 100; i <= maxWeight * 100; i = i + 1) {
        this.weightData.push((i / 100).toFixed(2));
      }
    },
    updateCostom() {
      let payload = {
        key: "size",
        content: this.size,
      };
      this.$store.dispatch("updateCostom", payload);
    },
    updateLength(data) {
      this.size.length = data;
      this.showDropDown_size = false;
      this.changeWeightLimit(data);
      this.size.weight = "";
      this.orderPrice = "--";
    },
    updateWeight(data) {
      this.size.weight = data;
      this.showDropDown_weight = false;
    },
    updateWay(way, index) {
      this.size.way = way;
      this.changeLengthLimit(this.size.way);
      //樣式
      let wayItems = document.querySelectorAll(".wayItem");
      wayItems.forEach((item) => {
        item.classList.remove("active");
      });
      wayItems[index].classList.add("active");
      this.size.length = "";
      this.size.weight = "";
      this.orderPrice = "--";
      //關掉尺寸及重量的下拉選單
      this.showDropDown_size = false;
      this.showDropDown_weight = false;
    },
    updateUnit(data) {
      this.size.unit = data;
      if (this.size.unit == "cm") {
        document.querySelector(".cm").classList.add("activeCm");
        document.querySelector(".inch").classList.remove("activeInch");
      } else if (this.size.unit == "tin") {
        document.querySelector(".cm").classList.remove("activeCm");
        document.querySelector(".inch").classList.add("activeInch");
      }
      this.size.length = "";
      this.size.weight = "";
      this.changeLengthLimit(this.size.way);
      this.orderPrice = "--";
      //關掉尺寸及重量的下拉選單
      this.showDropDown_size = false;
      this.showDropDown_weight = false;
    },
    saveToCookie() {
      let cartorder = [this.$store.getters.currentCustom];
      let localStorageCartorder = JSON.parse(localStorage.getItem("cartorder"));
      if (localStorageCartorder) {
        cartorder = [...localStorageCartorder, ...cartorder];
        localStorage.setItem("cartorder", JSON.stringify(cartorder));
        this.updateCartOrderNum();
      } else {
        localStorage.setItem("cartorder", JSON.stringify(cartorder));
        this.updateCartOrderNum();
      }
    },
    updateCartOrderNum() {
      let localStorageCartorder = JSON.parse(localStorage.getItem("cartorder"));
      if (localStorageCartorder === null) {
        this.$store.dispatch("updateCartOrderNum", 0);
      } else {
        let updateCartOrderNum = 0;
        localStorageCartorder.forEach((item) => {
          updateCartOrderNum = updateCartOrderNum + item.amount;
        });
        this.$store.dispatch("updateCartOrderNum", updateCartOrderNum);
      }
    },
    lightboxControl(image) {
      this.closeLightbox = !this.closeLightbox;
      if (image.default) {
        this.lightboxImg = image.default;
        return;
      }

      if (this.$store.getters.getComponentCode === "AF") {
        this.lightboxImg = image.af;
        return;
      }

      if (this.$store.getters.getComponentCode === "AG") {
        this.lightboxImg = image.ag;
        return;
      }

      if (this.$store.getters.getComponentCode === "AW") {
        this.lightboxImg = image.aw;
        return;
      }
      if (this.$store.getters.getComponentCode === "AX") {
        this.lightboxImg = image.ax;
        return;
      }
    },
    getOrderPrice() {
      let orderData = [this.size];
      axios({
        url: this.$store.getters.getGlobalUrl + "gold/calculate",
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: orderData,
      })
        .then((response) => {
          this.orderPrice = response.data.data[0].price;
        })
        .catch((e) => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    },
    addToCart() {
      if (this.size.length == "") {
        alert("您尚未選擇尺寸哦");
      } else if (this.size.weight == "") {
        alert("您尚未選擇重量哦");
      } else {
        this.updateCostom();
        this.$store.dispatch("getPicSendUrl");
        this.getImageUrlLoading = false;
        window.scrollTo(0, 0);
      }
    },
    timeToLeave() {
      setTimeout(
        function () {
          this.$router.push("/gold/customize/customize_star");
          this.$store.dispatch("updataCanvasDataUrl", "");
        }.bind(this),
        3600000
      );
    },
    showDropDownSize() {
      this.showDropDown_size = !this.showDropDown_size;
    },
  },
  computed: {
    wayData() {
      let currentComponentWay = this.$store.getters.wayByComponentName(
        this.$store.getters.currentCustom.style
      );
      return this.$store.getters.getWayOptions.filter((way) =>
        currentComponentWay.includes(way.wayCode)
      );
    },
    defaultWayByStyle() {
      let currentComponentWay = this.$store.getters.wayByComponentName(
        this.$store.getters.currentCustom.style
      );
      return currentComponentWay[0];
    },
    isLength() {
      return this.size.length;
    },
    isWeight() {
      return this.size.weight;
    },
    isUnitCm() {
      if (this.size.unit == "cm") {
        return true;
      } else {
        return false;
      }
    },
    imgDataUrl() {
      return this.$store.getters.getCanvasDataUrl;
    },
    getImageUrl() {
      return this.$store.getters.getImageUrl;
    },
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.note {
  color: $secondaryColor2;
}
button {
  @extend %button;
}
.customize_container {
  position: relative;
  margin-top: 30px;
  margin-bottom: 60px;
  ::v-deep .step-pre-next {
    @include table {
      display: block;
      top: 360px;
    }
  }
}
.customize_title {
  color: $primaryDeepColor;
  font-size: 24px;
  font-family: "NotoSerifTC-Bold";
}
.center {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 30px 120px 60px 120px;
  z-index: 99;
  position: relative;
  @media all and (min-width: 1440px) {
    margin: 30px 8.3%;
  }
  @include table {
    grid-template-columns: 1fr;
    justify-items: center;
    z-index: 1;
  }
  @include betweenPhoneTable {
    margin: 30px 0px;
  }
}
.customize_step4 {
  color: $secondaryDeepColor1;
  font-size: 17px;
  text-align: left;
  padding-left: 50px;
  @include tablePro {
    padding-left: 20px;
  }
  @include betweenTableTablePro {
    padding-left: 0px;
  }
  @include table {
    order: 2;
  }
  @include betweenPhoneTable {
    padding: 0 20px;
  }
}
.size_weight {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  margin-bottom: 30px;
  margin-top: 30px;
  @include desktop {
    grid-template-columns: 1fr;
    & > div:nth-of-type(1) {
      order: 1;
    }
    & > div:nth-of-type(2) {
      order: 3;
    }
    & > div:nth-of-type(3) {
      order: 2;
    }
    & > div:nth-of-type(4) {
      order: 4;
    }
  }
}
.description {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;
  @include table {
    justify-content: center;
  }
  .item {
    flex: 0 1 270px;
    padding: 8px 0;
    margin-right: 16px;
    font-size: 24px;
    text-align: center;
    letter-spacing: 1.4px;
    color: $primaryDeepColor;
    border: 1px $primaryLightColor solid;
    cursor: pointer;
    &:hover {
      background-color: $primaryLightColor;
      color: $secondaryColor3;
    }
    @include betweenDesktopTablePro {
      font-size: 17px;
      flex: 0 0 190px;
    }
    @include betweenTableTablePro {
      font-size: 15px;
      flex: 0 0 140px;
    }
    @include table {
      font-size: 24px;
      flex: 1 1 100%;
      margin-right: 0;
    }
  }
  span {
    margin-right: 5px;
    &:hover {
      cursor: pointer;
    }
  }
  .active {
    background-color: $primaryLightColor;
    color: $secondaryColor3;
  }
}
.gold_note {
  margin-top: 15px;
  margin-bottom: 15px;
}
.gold_price {
  color: $primaryLightColor;
}
.cart_price {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 30px;
  button {
    margin-right: 16px;
  }
  @media all and (max-width: 1155px) {
    align-items: flex-start;
    flex-direction: column-reverse;
  }
  @include table {
    align-items: center;
  }
  .total_price {
    color: $primaryDeepColor;
    font-weight: bold;
    font-size: 30px;
    @include table {
      margin-top: 0;
      margin-bottom: 16px;
    }
  }
}
.pic_changed {
  width: 500px;
  margin-bottom: 30px;
  padding: 0 10px;
  img {
    width: 500px;
    height: 400px;
    object-fit: contain;
  }
  @include betweenTableTablePro {
    width: 400px;
    img {
      width: 400px;
      height: 320px;
      object-fit: contain;
    }
  }
  @include table {
    order: 1;
    width: 350px;
    margin-bottom: 115px;
    padding: 0px;
    img {
      width: 350px;
      height: 280px;
      object-fit: contain;
    }
  }
  @include phone {
    width: 320px;
    margin-bottom: 150px;
    img {
      width: 320px;
      height: 256px;
      object-fit: contain;
    }
  }
}

//btn of cm and inch
.size-container {
  display: flex;
  align-items: center;
  position: relative;
  max-width: 405px;
}
.cm_inch {
  display: flex;
  position: absolute;
  right: 0;
  height: 30px;
  width: 112px;
  background: transparent;
  border-radius: 25px;
  border: 1px $primaryDeepColor solid;
  color: $primaryDeepColor;
  text-align: center;
  line-height: 30px;
  font-size: 15px;
  & > div {
    width: 50%;
  }
  & > .cm {
    border-right: 1px $primaryDeepColor solid;
  }
  & > div:hover {
    color: $secondaryColor3;
    background: $primaryDeepColor;
  }
  & > .cm:hover {
    border-radius: 25px 0px 0px 25px;
  }
  & > .inch:hover {
    border-radius: 0px 25px 25px 0px;
  }
  .activeCm {
    color: $secondaryColor3;
    background: $primaryDeepColor;
    border-radius: 25px 0px 0px 25px;
  }
  .activeInch {
    color: $secondaryColor3;
    background: $primaryDeepColor;
    border-radius: 0px 25px 25px 0px;
  }
}

//dropdown
.dropdown_title {
  position: relative;
  a,
  .item {
    color: $secondaryDeepColor1;
    text-decoration: none;
    display: flex;
    align-items: center;
    border: 1px $primaryDeepColor solid;
    background-color: #fefff9;
    padding: 15px 15px 15px 10px;
    max-width: 405px;
    width: 100%;
  }
  .item:hover {
    color: $secondaryColor3;
    background-color: $primaryLightColor;
  }
  .title-color {
    color: $secondaryLightColor1;
  }
}
ul {
  display: block;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.choice {
  position: absolute;
  width: 100%;
  z-index: 99;
  max-height: 365px;
  overflow-y: scroll;
  max-width: 405px;
}
.fa {
  margin-left: auto;
  color: $primaryLightColor;
}
.lightbox {
  position: fixed;
  top: 0;
  z-index: 1111111;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  .center-container {
    flex: 0 0 60vmin;
    @include betweenPhoneTable {
      flex: 0 0 90vmin;
    }
  }
  img {
    width: 100%;
    height: auto;
  }
  .lightbox-close {
    box-sizing: border-box;
    max-width: 45px;
    max-height: 45px;
    padding: 8px;
    background: $primaryDeepColor;
    color: #fff;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.displaynone {
  display: none;
}
//loading
.load {
  display: flex;
  min-height: calc(100vh - 377px);
  justify-content: center;
  align-items: center;
}
.load .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}
.load .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}
.load .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}
.line {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin: 3px;
  border-radius: 15px;
  background-color: #a8894c;
}
.loading-text {
  color: #a8894c;
  margin-left: 20px;
}
@keyframes loadingC {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
